import { DetailAction } from '../DetailAction';
import { DetailTranslationKeys, ErrorTranslationKeys } from '../../../../api/models/TranslationKeys';
import { SubscriptionTypes } from './SubscriptionSettings.types';
import { SelectOptionDialog } from '../../../../components/option/SelectOptionDialog';
import { Backend } from '../../../../api/Backend';
import { Recording } from '../../../../api/user/RecordingApi.types';
import { IProgramDetail } from '../../../../api/models/AndromeTV.types';
import { OptionData } from '../../../../components/option/OptionData';
import { Lightning } from '@lightningjs/sdk';

export class EpgCancelRecordingAction extends DetailAction {
  /**
   * @param {Backend} backend
   * @param {Recording} recording
   * @param {IProgramDetail} program
   * @param {boolean} isParentRecordingPage
   */
  private recording: Recording;
  private program: IProgramDetail;
  private isParentRecordingPage: boolean;
  constructor(backend: Backend, recording: Recording, program: IProgramDetail, isParentRecordingPage = false) {
    super(backend);
    this.recording = recording;
    this.program = program;
    this.isParentRecordingPage = isParentRecordingPage;
  }

  override doAction(modalOwner: Lightning.Component | undefined = undefined) {
    const options = this.getOptions();
    this.openCancelDialog(options, (type: OptionData) => {
      const typ = type.value as SubscriptionTypes;
      this._backend.cachedRecordingsApi
        .cancelSubscription(this._backend, typ, this.recording)
        .then(() => {
          this.owner?.fireAncestors('$closeDialog');
          this.owner?.fireAncestors('$reloadDetailContent');
          if (this.isParentRecordingPage) {
            // signal cmsGrid to remove item
            if (modalOwner) modalOwner.fireAncestors('$removeEpgElement', modalOwner, typ);
          }
        })
        .catch(() => {
          this.owner?.fireAncestors(
            '$showMessage',
            this._backend.translations.forKey(ErrorTranslationKeys.error_recording_delete_failed)
          );
        });
    });
  }

  openCancelDialog(options: OptionData[], callback: any) {
    const title = `${this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_popup_title)} ${
      this.program.title
    }`;
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        title: title,
        options: options,
        onSuccess: callback,
        onCancelled: () => {
          this.owner?.fireAncestors('$closeDialog');
        },
      },
    });
  }

  getOptions() {
    const result: OptionData[] = [
      {
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_program),
        value: SubscriptionTypes.PROGRAM,
        options: [],
      },
    ];
    if (this.recording.seriesSubscription || this.recording.seasonSubscription) {
      result.push({
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_season),
        value: SubscriptionTypes.SEASON,
        options: [],
      });
    }

    if (this.recording.seriesSubscription) {
      result.push({
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_series),
        value: SubscriptionTypes.SERIES,
        options: [],
      });
    }
    return result;
  }
}
